import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { OccupationsContract } from '@packages/contracts';

import { OCCUPATION_QUERY_KEY } from '../query-keys';

type OccupationChildrenRoute = typeof OccupationsContract['listChildrenById'];
type OccupationChildrenResponse = ClientInferResponseBody<OccupationChildrenRoute, 200>['result']['occupations'];

export type OccupationChildrenQueryOptions = UseQueryOptions<
	OccupationChildrenRoute,
	ClientArgs,
	OccupationChildrenResponse
>;

export const createOccupationChildrenQueryOptions = (occupationId?: string): OccupationChildrenQueryOptions => ({
	queryData: { params: { occupationId: occupationId ?? '' } },
	queryKey:  OCCUPATION_QUERY_KEY.children(occupationId ?? 'all'),

	retry: (failureCount, error) => {
		if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

		return failureCount < 3;
	},
	select: res => res.body.result.occupations,
});
